import Label, { VARIANTS } from '../label/label';

import styles from './page_header.module.css';

export type PageHeaderLabelProps = {
  value?: number;
};

export function PageHeaderLabel({ value }: PageHeaderLabelProps) {
  if (value && value > 0) {
    return (
      <Label variant={VARIANTS.GRAY} className={styles.label}>
        {value}
      </Label>
    );
  }
  return null;
}
